import { render, staticRenderFns } from "./Ftp.vue?vue&type=template&id=425d610e&scoped=true"
import script from "./Ftp.vue?vue&type=script&lang=js"
export * from "./Ftp.vue?vue&type=script&lang=js"
import style0 from "./Ftp.vue?vue&type=style&index=0&id=425d610e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "425d610e",
  null
  
)

export default component.exports